import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';

function createValidationCallback(validationRules) {
  return function (value) {
    return validationRules.reduce(function (currentExceptions, _ref) {
      var validate = _ref.validate,
          type = _ref.type,
          getMessage = _ref.getMessage,
          rest = _objectWithoutProperties(_ref, ["validate", "type", "getMessage"]);

      var didPrevRuleBreakOnException = currentExceptions.length && currentExceptions[currentExceptions.length - 1].breakOnException;

      if (!didPrevRuleBreakOnException && !validate(value, currentExceptions)) {
        return currentExceptions.concat(_assign({}, rest, {
          type: type,
          message: getMessage(value)
        }));
      }

      return currentExceptions;
    }, []);
  };
}

export default function useValidation(validationRules) {
  var _React$useState = React.useState([]),
      fieldStates = _React$useState[0],
      setFieldStates = _React$useState[1];

  var validationCallbackRef = React.useRef();
  var validationCallback = React.useCallback(function (value) {
    setFieldStates(validationCallbackRef.current(value));
  }, []);
  useEffect(function () {
    validationCallbackRef.current = createValidationCallback(validationRules);
  }, [validationRules]);
  return [fieldStates, validationCallback];
}